import type { SportItem } from '../types/sport-icon.type';

const sports: SportItem[] = [
	{ id: 1, label: 'Softball', icon: 's_softball' },
	{ id: 2, label: 'Basketball', icon: 's_basketball' },
	{ id: 3, label: 'Football', icon: 's_football' },
	{ id: 4, label: 'Soccer', icon: 's_soccer' },
	{ id: 5, label: 'Bowling', icon: 's_bowling' },
	{ id: 6, label: 'Bocce ball', icon: 's_bocceball' },
	{ id: 7, label: 'Cornhole', icon: 's_cornhole' },
	{ id: 8, label: 'Dodgeball', icon: 's_dodgeball' },
	{ id: 9, label: 'Frisbee', icon: 's_frisbee' },
	{ id: 10, label: 'Hockey', icon: 's_hockey' },
	{ id: 11, label: 'Kickball', icon: 's_kickball' },
	{ id: 13, label: 'Ping pong', icon: 's_pingpong' },
	{ id: 14, label: 'Rugby', icon: 's_rugby' },
	{ id: 15, label: 'Skeeball', icon: 's_skeeball' },
	{ id: 16, label: 'Tennis', icon: 's_tennis' },
	{ id: 17, label: 'Volleyball', icon: 's_vollyball' },
	{ id: 18, label: 'Wiffleball', icon: 's_wiffleball' },
	{ id: 19, label: 'Badminton', icon: 's_badminton' },
	{ id: 20, label: 'Fitness', icon: 's_fitness' },
	{ id: 21, label: 'Golf', icon: 's_golf' },
	{ id: 22, label: 'Pilates', icon: 's_pilatis' },
	{ id: 23, label: 'Running', icon: 's_running' },
	{ id: 24, label: 'Skiing', icon: 's_skiing' },
	{ id: 25, label: 'Snowboarding', icon: 's_snowboarding' },
	{ id: 26, label: 'Yoga', icon: 's_yoga' },
	{ id: 27, label: 'Broomball', icon: 's_broomball' },
	{ id: 28, label: 'Cricket', icon: 's_cricket' },
	{ id: 29, label: 'Crossfit', icon: 's_crossfit' },
	{ id: 30, label: 'Cycling', icon: 's_cycling' },
	{ id: 31, label: 'Field hockey', icon: 's_fieldhockey' },
	{ id: 32, label: 'Raquetball', icon: 's_raquetball' },
	{ id: 33, label: 'Spinning', icon: 's_spinning' },
	{ id: 34, label: 'Squash', icon: 's_squash' },
	{ id: 35, label: 'Surfing', icon: 's_surfing' },
	{ id: 36, label: 'Swimming', icon: 's_swiming' },
	{ id: 37, label: 'Windsurfing', icon: 's_windsurfing' },
	{ id: 38, label: 'Adventure', icon: 's_adventure' },
	{ id: 39, label: 'Boxing', icon: 's_boxing' },
	{ id: 40, label: 'Baseball', icon: 's_baseball' },
	{ id: 41, label: 'Dance', icon: 's_dance' },
	{ id: 42, label: 'Kickboxing', icon: 's_kickboxing' },
	{ id: 43, label: 'Martial arts', icon: 's_martialarts' },
	{ id: 44, label: 'Outdoor', icon: 's_outdoor' },
	{ id: 45, label: 'Rowing', icon: 's_rowing' },
	{ id: 46, label: 'Sailing', icon: 's_sailing' },
	{ id: 47, label: 'Sup', icon: 's_sup' },
	{ id: 48, label: 'Triathlon', icon: 's_triathlon' },
	{ id: 49, label: 'Handball', icon: 's_handball' },
	{ id: 50, label: 'Catchball', icon: 's_catchball' },
	{ id: 51, label: 'Blitzball', icon: 's_blitzball' },
	{ id: 52, label: 'Roller derby', icon: 's_rollerderby' },
	{ id: 53, label: 'Skating', icon: 's_skating' },
	{ id: 54, label: 'Pickleball', icon: 's_pickleball' },
	{ id: 55, label: 'Axe Throwing', icon: 's_throwingaxe' },
	{ id: 56, label: 'Futsal', icon: 's_futsal' },
	{ id: 57, label: 'Birthday', icon: 's_birthday' },
	{ id: 58, label: 'Corporate Events', icon: 's_corporateevents' },
	{ id: 59, label: 'Curling', icon: 's_curling' },
	{ id: 60, label: 'Gymnastics', icon: 's_gymnastics' },
	{ id: 61, label: 'Figure Skating', icon: 's_figure-skating' },
	{ id: 62, label: 'Cheer', icon: 's_cheer' },
	{ id: 63, label: 'Ninja & Parkour', icon: 's_ninja_parkour' },
	{ id: 999, label: 'Other', icon: 's_other' },
];

export const getSportByIds = (ids: number[]): SportItem[] => {
	return sports.filter(sport => ids.includes(sport.id));
};

export default sports;
